import TvaFormController from './tva.form.controller';

export default {
    template: require('./tva.form.html'),
    controller: TvaFormController
};
